import { UserWallets } from '../UserWallets';

import { ScUserPanel, ScUserPanelMobile } from './styled';

export const UserPanel = () => (
  <ScUserPanel>
    <UserWallets />
  </ScUserPanel>
);

export const UserPanelMobile = () => (
  <ScUserPanelMobile>
    <UserWallets menuMode />
  </ScUserPanelMobile>
);
